if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        if (theme.settings.afterAtc !== 'no-js') {
          this.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      // Ensure pincode is valid before proceeding with ATC
      if (window.validatePincode) {
        this.submitBtn.setAttribute('aria-disabled', 'true');
        this.submitBtn.classList.add('is-loading');
        
        const isPincodeValid = await window.validatePincode();
        if (!isPincodeValid) {
          this.submitBtn.removeAttribute('aria-disabled');
          this.submitBtn.classList.remove('is-loading');
          window.navigator.vibrate?.(50);
          return; // Stop form submission
        }
      }

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');
      const formData = new FormData(this.form);
      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      const productCard = document.querySelectorAll('.free-product-card');
      const variantIds = [];

      // Fetch current cart to check for existing free products by uniqueId
      let oldCartDataForPresence = null;
      try {
        const cartResp = await fetch(`${theme.routes.cart}.js`);
        if (cartResp && cartResp.ok) {
          oldCartDataForPresence = await cartResp.json();
        }
      } catch (e) {
        // If cart fetch fails, proceed to add both main and free products (safe fallback)
        oldCartDataForPresence = null;
      }

      productCard.forEach((card) => {
        const ID = card.dataset.freeProductId;
        const propertyValue = 'Free product';
        const unique_id = card.dataset.parentProductId;
        const variant_id = card.dataset.productVariantId;

        if (!ID) return;

        // If old cart contains a line item with matching properties.uniqueId, skip adding the free product
        let alreadyHasFree = false;
        if (oldCartDataForPresence && oldCartDataForPresence.items && unique_id) {
          alreadyHasFree = oldCartDataForPresence.items.some((itm) => {
            return itm.properties && itm.properties.uniqueId === unique_id;
          });
        }

        if (!alreadyHasFree) {
          appendVariantsToFormData(ID, unique_id);
        }
      });
      function appendVariantsToFormData(ID, unique_id) {

          const properties = {
            uniqueId: unique_id
          }

          formData.append('properties[uniqueId]', unique_id)

          variantIds.push({
            id: ID,
            quantity: 1,
            properties: properties
          });

          // Append the Bundle product to the form data
          variantIds.forEach((item, index) => {
            formData.append(`items[${index}][id]`, item.id)
            formData.append(`items[${index}][quantity]`, item.quantity)

            Object.keys(item.properties).forEach((key) => {
              formData.append(
                `items[${index}][properties][${key}]`,
                item.properties[key]
              )
            })
          })
        }

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();
        let error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '));
        }

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          ProductForm.updateCartIcon(data);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
                !quickAddDrawer && theme.settings.afterAtc === 'drawer'
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
          }, 700);
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === data.variant_id
        )[0];

        // Check if product was already in the cart
        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === data.quantity)
                ? itemInOldCart.quantity : data.quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id
            }
          }));
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg.textContent
          }
        }));
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}

/* Pincode checker */
document.addEventListener("DOMContentLoaded", function () {
  const pincodeInput = document.getElementById("pincode");
  const checkBtn = document.getElementById("check-pincode-btn");
  const resultDiv = document.getElementById("pincode-result");
  const addToCartBtn = document.querySelector('[name="add"]');
  const buyNowBtn = document.querySelector("shopify-buy-it-now-button button");

  if (!pincodeInput || !resultDiv || !addToCartBtn) return;

  const SHEET_URL = "https://script.google.com/macros/s/AKfycbxJsSu3EpNlTT82f0RHq429zKNpJfWy272AjLxjTSUQRxLrw9nizvS5fLINdYAHVvEo/exec";

  let allowedPinsSet = null;

  let currentValidPincode = null;

  function disableBuyNow() {
    if (buyNowBtn) {
      buyNowBtn.setAttribute("disabled", "true");
      buyNowBtn.disabled = true;
    }
    const container = document.querySelector("shopify-buy-it-now-button");
    if (container) {
      container.style.pointerEvents = "none";
      container.style.opacity = "0.5";
    }
  }

  function enableBuyNow() {
    if (buyNowBtn) {
      buyNowBtn.removeAttribute("disabled");
      buyNowBtn.disabled = false;
    }
    const container = document.querySelector("shopify-buy-it-now-button");
    if (container) {
      container.style.pointerEvents = "auto";
      container.style.opacity = "1";
    }
  }

  // Disable initially
  disableBuyNow();

  // Reset on typing
  pincodeInput.addEventListener("input", function () {
    resultDiv.innerHTML = "";
    resultDiv.style.color = "";
    pincodeInput.classList.remove("error-highlight");
    currentValidPincode = null;
    disableBuyNow();
  });

  // Fetch and normalize pincodes
  async function fetchPincodes() {
    if (allowedPinsSet) return allowedPinsSet;

    const response = await fetch(SHEET_URL);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const data = await response.json();

    let allowedPins = [];

    if (Array.isArray(data)) {
      allowedPins = data.map(item => {
        if (Array.isArray(item)) {
          return item[0]?.toString().trim();
        } else if (typeof item === "object" && item !== null) {
          return Object.values(item)[0]?.toString().trim();
        } else {
          return item?.toString().trim();
        }
      });
    } else if (data.values) {
      allowedPins = data.values.map(row => row[0]?.toString().trim());
    } else if (data.data) {
      allowedPins = data.data.map(item => item?.toString().trim());
    }

    // Remove empty/undefined values
    allowedPins = allowedPins.filter(Boolean);
    allowedPinsSet = new Set(allowedPins);
    return allowedPinsSet;
  }

  // Validate pincode globally so ProductForm can use it
  window.validatePincode = async function () {
    const pincode = pincodeInput.value.trim();

    if (!pincode) {
      pincodeInput.classList.add("error-highlight");
      resultDiv.innerHTML = "Please enter your pincode.";
      resultDiv.style.color = "red";
      return false;
    } else {
      pincodeInput.classList.remove("error-highlight");
    }

    if (currentValidPincode === pincode) {
      return true; // Use cached valid state
    }

    try {
      resultDiv.innerHTML = "Checking pincode…";
      resultDiv.style.color = "black";

      const allowedPins = await fetchPincodes();

      if (!allowedPins.has(pincode)) {
        pincodeInput.classList.add("error-highlight");
        resultDiv.innerHTML =
          "Delivery isn’t available in your area at the moment. Please give us a call for more details—we’ll be happy to help!";
        resultDiv.style.color = "red";
        return false;
      }

      resultDiv.innerHTML = "Delivery available!";
      resultDiv.style.color = "green";
      currentValidPincode = pincode;
      enableBuyNow();
      return true;
    } catch (err) {
      console.error("API fetch error:", err);
      resultDiv.innerHTML = "Error checking pincode. Please try again.";
      resultDiv.style.color = "red";
      return false;
    }
  };

  // Button click
  checkBtn?.addEventListener("click", window.validatePincode);

  // Buy Now intercept
  if (buyNowBtn) {
    buyNowBtn.addEventListener("click", function (evt) {
      const pincode = pincodeInput.value.trim();
      if (!pincode || currentValidPincode !== pincode) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        
        // Trigger validation check visually, requires a second click to actually buy
        window.validatePincode();
      }
    }, true); // Use capture phase to stop native Shopify click before it starts
  }
});

/*  Expert Advice ------------------------------------------------------ */

document.addEventListener("DOMContentLoaded", function () {
  const scriptURL = "https://script.google.com/macros/s/AKfycbw5_kkbwvBxfOuhJ9jOZq3jmrJm1l8uBRKOIoWvmraJ2dP0jH5GWBeLf08CBFTk8Uu0Dw/exec";
  const form = document.forms["submit-to-google-sheet"];
  const successmsg = document.getElementById("success-msg");
  const phoneInput = document.getElementById("phoneNumber");
  const expertPincodeInput = document.getElementById("pincode");

  if (!form || !successmsg) return;

  // Allow only digits
  [phoneInput, expertPincodeInput].forEach((input) => {
    if (input) {
      input.addEventListener("input", function () {
        this.value = this.value.replace(/\D/g, ""); // remove non-numeric chars
      });
    }
  });
  
  form.addEventListener("submit", (e) => {
    e.preventDefault();

    // Add timestamp before submit
    const submittedAt = document.getElementById("submittedAt");
    if (submittedAt) submittedAt.value = new Date().toLocaleString();

    // Show instant feedback
    successmsg.style.color = "blue";
    successmsg.innerHTML = "Submitting...";

    fetch(scriptURL, { method: "POST", body: new FormData(form) })
      .then((response) => {
        successmsg.style.color = "green";
        successmsg.innerHTML = "Thank you! We will contact you soon.";
        setTimeout(() => {
          successmsg.innerHTML = "";
        }, 2000);
        form.reset();
      })
      .catch((error) => {
        console.error("Error:", error);
        successmsg.style.color = "red";
        successmsg.innerText = "Something went wrong. Please try again.";
      });
  });
});
/* End of Expert Advice */